module.exports = __webpack_public_path__ + "img/baac.82431882.png";